import { Component, Vue } from 'vue-property-decorator'
import { videoDetail, videoSetUseful, videoLoginDetail } from '@/api'
import { QuestionDetail, SetUseful } from '@/types/type'
import Header from '@/components/componentWap/Header.vue'
import VdieoComponent from '@/components/componentWap/VdieoComponent.vue'
import ActiveComponent from '@/components/ActiveComponent.vue'
@Component({
    name: 'videoDetail',
    components: {
        Header,
        VdieoComponent,
        ActiveComponent
    }
})
export default class extends Vue {
    private videoId = this.$route.query.videoId as string
    private editData: QuestionDetail = new QuestionDetail()
    get showIframe() {
        return this.editData.resSubType === 23
    }
    get isUseful() {
        return this.editData.useful === 1
    }
    private async getVideoDetail() {
        let res
        if (this.$isLogin) {
            res = await videoLoginDetail(this.videoId)
        } else {
            res = await videoDetail(this.videoId)
        }
        this.editData = res.data
    }
    // 评价
    private async evaluate(id: number) {
        if (id === this.editData.useful) {
            return
        }
        const params = new SetUseful()
        params.useful = id
        params.id = this.videoId
        await videoSetUseful(params)
        this.editData.useful = id
    }
    // 上下篇
    private async changeContent(type: string) {
        if (type === 'pre') {
            if (this.editData.preVO && this.editData.preVO.id) {
                this.videoId = this.editData.preVO.id
            }
        } else {
            if (this.editData.nextVO && this.editData.nextVO.id) {
                this.videoId = this.editData.nextVO.id
            }
        }
        let res
        if (this.$isLogin) {
            res = await videoLoginDetail(this.videoId)
        } else {
            res = await videoDetail(this.videoId)
        }
        this.editData = res.data
    }
    async created() {
        this.getVideoDetail()
    }
}